
import { Injectable } from '@angular/core';
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';
import { TokenService } from '../services/core.token.service';
@Injectable()
export class InterceptorConfigServiceAngular implements HttpInterceptor {

    constructor(private TokenService: TokenService) {}

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        const userToken = this.TokenService.getToken() || '';
        const modifiedReq = req.clone({ 
            setHeaders: {
                'GFAuthToken': userToken,
                'X-Requested-With': 'XMLHttpRequest'
            },
        });
        return next.handle(modifiedReq);
    }
  }